import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getUserDetail, isLoggedInUser, isWhiteListed } from '../constants/function';
import cookieStorage from '../services/cookie-storage';

const DebugRoute = () => {
  const history = useHistory();
  const location = useLocation();
  const userData = getUserDetail();
  
  const debugInfo = {
    currentPath: location.pathname,
    isLoggedIn: isLoggedInUser(),
    isWhiteListed: isWhiteListed(),
    authCookie: cookieStorage.getCookie("Authorization"),
    userData: userData,
    hasBirthYear: userData && userData["birthYear"],
    localStorageUserData: localStorage.getItem("userData"),
    locationState: location.state
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', margin: '20px' }}>
      <h2>Debug Route Information</h2>
      <pre>{JSON.stringify(debugInfo, null, 2)}</pre>
      <button onClick={() => history.push('/')}>Go to Root</button>
      <button onClick={() => history.push('/app/home')}>Go to App Home</button>
      <button onClick={() => history.push('/signup')}>Go to Signup</button>
      <button onClick={() => {
        cookieStorage.removeCookie("Authorization");
        localStorage.removeItem("userData");
        localStorage.removeItem("isWhiteListed");
        window.location.reload();
      }}>Clear Auth and Reload</button>
    </div>
  );
};

export default DebugRoute;